// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_8-0";
export var skeletonCard = "_8-1";